<template>
  <div class="over_layout">
    <section class="upgrade">
      <a style="cursor: pointer" @click="$store.commit('paymentModal', true)">{{ $store.getters.t('create_resume') }}</a>
    </section>
    <section class="news_page">
      <div class="wrapper">
        <bred-crumbs :navigation="navigateUrls()" v-if="post.id"></bred-crumbs>
        <div class="pages_header">
          <div class="lines">
            <h1>{{ post.name }}</h1>
          </div>
        </div>
        <div class="news_page_block">
          <div class="all_news_block fr-view text_area" v-html="post.content"></div>
        </div>
      </div>
    </section>
    <active-posts :posts="active_posts"></active-posts>
    <div class="padding_bottom"></div>
  </div>
</template>

<script>
import ActivePosts from "../../widgets/ActivePosts.vue";
import BredCrumbs from "../../widgets/BreadCrumbs.vue";
import Seo from "../../../mixins/seo.js";

export default {
  mixins: [Seo],
  components: {
    "active-posts": ActivePosts,
    "bred-crumbs": BredCrumbs
  },
  data() {
    return {
      post: {},
      active_posts: {}
    };
  },
  mounted() {
    this.run();
  },
  watch: {
    $route(to, from) {
      if (
        to.params.lang != from.params.lang &&
        to.params.category == from.params.category &&
        to.params.post == from.params.post
      ) {
        this.redirectUrl("blog", { lang: this.$store.getters.locale });
      } else if (
        to.params.lang == from.params.lang &&
        to.params.category == from.params.category &&
        to.params.post != from.params.post
      ) {
        this.getPost();
      } else if (
        to.params.lang != from.params.lang ||
        to.params.category != from.params.category
      ) {
        this.run();
      }
    }
  },
  methods: {
    getPost() {
      this.$http({
        method: "get",
        url: `/api/blog/${this.$route.params.category}/${
          this.$route.params.post
        }`
      }).then(res => {
        this.post = res.data.post;
        this.setSeo(this.post.seo_title, this.post.seo_description);
        this.active_posts = res.data.activePosts;
      });
    },
    redirectUrl(name, params) {
      this.$router.push({ name: name, params: params });
    },
    run() {
      this.$parent.getData().then(changed => {
        if (changed) {
          this.getPost();
        }
      });
    },
    navigateUrls() {
      return [
        {
          title: "blog",
          page: "blog",
          params: {
            lang: this.$store.getters.locale
          }
        },
        {
          title: this.post.category,
          page: "blog.category",
          params: {
            lang: this.$store.getters.locale,
            category: this.post.category_slug
          }
        },
        {
          title: this.post.name
        }
      ];
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/blog/Blog-detail.vue